module.exports = __webpack_public_path__ + "img/Logo(en)_Dark.c3505ccb.svg";